<template>
  <main class="container">
    <div class="fixed_search">
      <div class="souhuo_search_bar">
        <div class="souhuo_search_label search-label-tmpl result-search-bar">
          <i class="iconfont icon-sousuo"></i>
          <span class='search_txt'>{{searchTig}}</span>
        </div>
      </div>
      <div class='sch-reult'>
        <div class='s_result'>
          <div :class="{'r_tab':true, 't_f23030': currentFilterItem === 'all','t_999':true}" @click="filterChange('all')">综合</div>
          <div :class="{'r_tab':true, 't_f23030': currentFilterItem === 'sale','t_999':true}" @click="filterChange('sale')">销量</div>
          <div :class="{'r_tab':true, 't_999':priceClickNum === 0,'t_f23030':priceClickNum !== 0}" @click="priceFilter">价格
            <div class='icon-div'>
            <div :class="{'sjx':true, 'sanjiaoxing-up':priceClickNum && priceClickNum%2 === 1, 'sjx-up':!priceClickNum || priceClickNum%2 !== 1}"></div>
            <div :class="{'sjx':true, 'sanjiaoxing-down':priceClickNum && priceClickNum%2 === 0, 'sjx-down':!priceClickNum || !priceClickNum%2 === 0}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="souhuo_list">
      <search-result-list
        :data-list="dataList"
        :scroll-disabled="scrollDisabled"
        :is-newcomer="isNewcomer"
        @unLogin="unLoginModal"
        @loadMore="loadMore"
        @entoDetailPage="entoDetailPage"
        @entoUnSearchDetailPage="entoUnSearchDetailPage">
      </search-result-list>
      <!-- line -->
      <segement-line
        v-if="haveMore"
        line-text="正在加载"
        :is-load="true">
      </segement-line>
      <segement-Line
        v-else-if="dataList.length === 0"
        line-text="暂无相关商品">
      </segement-Line>
      <segement-Line
        v-else
        line-text="没有更多商品啦">
      </segement-Line>
    </div>
    <div
      class='feedback_btn'
      @click="goFeedback"
      v-if="!haveMore && dataList.length === 0">没搜到？把你想找的商品告诉我们
    </div>
    <!-- 搜索页 -->
    <search-page
      v-if="searchPageShow"
      ref="searchPageRef"
      :query-search="searchTig"
      @goSearchResult="goSearchResult"
      @searchResult="searchResult"
      @hideInput="hideInput">
    </search-page>
  </main>
</template>

<script>
import {
  noLoginSouhuoList,
  loginSouhuoList,
  TBKProductListSearch,
  TBKProductListSearchNoLogin,
  GetTBKProductInfoSuper,
  GetTBKProductInfoSuperNologin
} from '@/api/souhuo'
import SegementLine from '@/components/puppetComponent/SegementLine'
import SearchResultList from './children/SearchResultList'
import SearchPage from '@/components/smartComponent/SearchPage'
import { Indicator, Toast } from 'mint-ui'
import Utils from '@/utils/base'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      searchTig: '',
      currentFilterItem: 'all',
      SAPPHomeSortType: 0,
      priceClickNum: 0,
      showView: false,
      dataLoading: true,
      dataList: [],
      haveMore: true,
      scrollDisabled: false,
      pageScrollTop: 0,
      container: null,
      searchPageShow: false,
      // 免搜排序相关
      sortType: 0,
      priceOrder: 1,
      currentPage: 1,
      isNewcomer: false, // 是否是新人
      // 免搜是否有数据
      unSearchIsNull: false,
      // 搜索是否有数据
      unSearchIsNotData: true,
      // 平台是否没商品了
      platformWithoutGoods: false
    }
  },
  components: {
    SegementLine,
    SearchResultList,
    SearchPage
  },
  mounted () {
    this.searchTig = this.$route.query.search
    // this.fetchDate()
    this.$nextTick(() => {
      this.searchBarElem = document.getElementsByClassName('result-search-bar')[0]
        .addEventListener('click', this.entoSearch, false)
      this.container = document.getElementsByClassName('container')[0]
      this.container.addEventListener('scroll', this.handleScroll)
    })
  },
  beforeDestroy () {
    this.container.removeEventListener('scroll', this.handleScroll)
    this.container = null
  },
  computed: {
    ...mapGetters([
      'loginState',
      'getIsApp',
      'getIsAuthorized'
    ])
  },
  methods: {
    ...mapMutations([
      'AUTHORIZE_POPUP_SHOW'
    ]),
    reFetchPage (from) {
      if ((from.name === 'goodsDetail' || from.name === 'unSearchDetail') && this.container) {
        this.$nextTick(() => {
          this.container.scrollTop = this.pageScrollTop
        })
      } else {
        this.searchTig = this.$route.query.search
        this.isNewcomer = Utils.getNewcomerStorage()
        this.dataList = []
        this.dataList.splice(0)
        this.pageScrollTop = 0
        this.isLastOne = false
        this.currentFilterItem = 'all'
        this.SAPPHomeSortType = 0
        this.priceClickNum = 0
        this.showView = false
        this.searchPageShow = false
        this.sortType = 0
        this.priceOrder = 1
        this.currentPage = 1
        this.fetchDate()
      }
    },
    fetchDate () {
      if (this.loginState) {
        this.fetchLoginData()
      } else {
        this.fetchNoLoginData()
      }
    },
    // 已登录获取
    fetchLoginData (isDropDown = false) {
      let params = {
        DropDown: isDropDown,
        ProductTitle: this.searchTig,
        BrandName: [],
        SAPPHomeSortType: this.SAPPHomeSortType,
        IsHomePage: false
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      loginSouhuoList(params).then(res => {
        this.handleListSuccess(res)
      }).catch(res => {
        this.haveMore = false
        Indicator.close()
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      })
    },
    // 未登录获取
    fetchNoLoginData (isDropDown = false) {
      let params = {
        DropDown: isDropDown,
        ProductTitle: this.searchTig,
        BrandName: [],
        SAPPHomeSortType: this.SAPPHomeSortType,
        IsHomePage: false
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      noLoginSouhuoList(params).then(res => {
        this.handleListSuccess(res)
      }).catch(res => {
        this.haveMore = false
        Indicator.close()
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      })
    },
    handleListSuccess (res) {
      this.dataList = [...this.dataList, ...res.DataList]
      this.isLastOne = res.BoolSID
      if (res.BoolSID) {
        this.platformWithoutGoods = true
        this.fetchUnSearchGoods()
      } else {
        this.haveMore = true
      }
      this.scrollDisabled = false
      Indicator.close()
    },
    // 免搜商品获取
    fetchUnSearchGoods () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        IsNotData: this.unSearchIsNotData,
        ProductName: this.searchTig,
        SortType: this.sortType,
        order: this.priceOrder,
        page: this.currentPage
      }
      this.scrollDisabled = true
      if (this.loginState) {
        TBKProductListSearch(params).then(res => {
          this.hanlderUnSearchResult(res)
        }).catch(err => {
          this.haveMore = false
          Indicator.close()
          Toast(err.ErrMsg)
        })
      } else {
        TBKProductListSearchNoLogin(params).then(res => {
          this.hanlderUnSearchResult(res)
        }).catch(err => {
          this.haveMore = false
          Indicator.close()
          Toast(err.ErrMsg)
        })
      }
    },
    // 处理免搜返回
    hanlderUnSearchResult (res) {
      let resList = res.Data.ResultList
      let unSearchDataList = []
      if (resList) {
        unSearchDataList = resList.map(item => {
          item.isUnsearch = true
          return item
        })
      }
      this.currentPage = res.Data.Page
      if (this.platformWithoutGoods && resList && resList.length > 0) {
        let isFirstNull = false
        // 首次搜索商品结果为空
        if (this.dataList.length <= 0) isFirstNull = true
        else isFirstNull = false
        this.dataList.push({
          platformWithoutGoods: true,
          isFirstNull: isFirstNull
        })
      }
      this.platformWithoutGoods = false
      this.dataList = [...this.dataList, ...unSearchDataList]
      // 无数据，不再下拉加载
      if (!resList || resList.length < 10) {
        this.unSearchIsNotData = true
        this.unSearchIsNull = true
        this.haveMore = false
      } else {
        this.unSearchIsNotData = false
        this.unSearchIsNull = false
        this.haveMore = true
      }
      this.scrollDisabled = false
      Indicator.close()
    },
    // 录入免搜商品
    writeInDbFromUnSearch (index) {
      let dataItem = this.dataList[index]
      if (!dataItem || !dataItem.isUnsearch) return
      // 此提交的字段刚好和免搜商品的字段对应
      let postData = {
        NumId: dataItem.NumId,
        ProductName: dataItem.ProductName,
        ProductHeadUrl: dataItem.ProductHeadUrl,
        ProductDetailUrl: dataItem.ProductDetailUrl,
        ProductPrice: dataItem.ProductPrice,
        ProductSaleCount: dataItem.ProductSaleCount,
        InComeRate: dataItem.InComeRate,
        PlatformNo: dataItem.PlatformNo,
        TBKUrl: dataItem.TBKUrl,
        TKLWord: dataItem.TKLWord,
        CouponId: dataItem.CouponId,
        CouponTotal: dataItem.CouponTotal,
        CouponResidue: dataItem.CouponResidue,
        CouponAmount: dataItem.CouponAmount,
        CouponBeginDate: new Date(parseInt(dataItem.CouponBeginDate.replace(/\D/ig, ''))),
        CouponEndDate: new Date(parseInt(dataItem.CouponEndDate.replace(/\D/ig, ''))),
        CouponUrl: dataItem.CouponUrl,
        CouponTKLWord: dataItem.CouponTKLWord,
        RealAmount: dataItem.RealAmount,
        ShopName: dataItem.ShopName,
        ShopDsr: dataItem.ShopDsr,
        SmallImages: dataItem.SmallImages,
        Volume: dataItem.Volume,
        UserType: dataItem.UserType
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      if (this.loginState) {
        this.hanlderUnSearchPromise(GetTBKProductInfoSuper(postData), dataItem.NumId)
      } else {
        this.hanlderUnSearchPromise(GetTBKProductInfoSuperNologin(postData), dataItem.NumId)
      }
    },
    // 处理免搜录入成功返回
    hanlderUnSearchPromise (resPromise, numId) {
      resPromise.then(res => {
        Indicator.close()
        if (res.Data) {
          this.$router.push({
            name: 'unSearchDetail',
            query: {
              id: res.Data,
              numId: numId,
              isHigh: true
            }
          })
        }
      }).catch((res) => {
        Indicator.close()
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      })
    },
    // 综合与销量选项
    filterChange (val) {
      if (this.currentFilterItem !== val) {
        // 隐藏品牌折叠栏、取消价格排序选项
        this.showView = false
        this.priceClickNum = 0
        this.currentFilterItem = val
        this.currentPage = 1
        this.priceOrder = 1
        if (val === 'all') {
          this.SAPPHomeSortType = 0
          this.sortType = 0
        } else {
          this.SAPPHomeSortType = 1
          this.sortType = 1
        }
        this.dataList = []
        this.scrollTop = 0
        this.haveMore = true
        this.unSearchIsNotData = true
        if (this.loginState) {
          this.fetchLoginData()
        } else {
          this.fetchNoLoginData()
        }
      }
    },
    // 价格帅选
    priceFilter () {
      // 隐藏品牌折叠栏、取消综合销量选项
      this.showView = false
      this.currentFilterItem = ''
      this.priceClickNum = this.priceClickNum + 1
      this.dataList = []
      this.scrollTop = 0
      this.haveMore = true
      this.unSearchIsNotData = true
      this.sortType = 2
      this.currentPage = 1
      if (this.priceClickNum % 2 !== 0) {
        // 价格从低到高
        this.SAPPHomeSortType = 3
        this.priceOrder = 0
        if (this.loginState) {
          this.fetchLoginData()
        } else {
          this.fetchNoLoginData()
        }
      } else {
        // 价格从高到底
        this.SAPPHomeSortType = 2
        this.priceOrder = 1
        if (this.loginState) {
          this.fetchLoginData()
        } else {
          this.fetchNoLoginData()
        }
      }
    },
    loadMore () {
      if (this.isLastOne) {
        if (this.unSearchIsNull) {
          this.haveMore = false
          return
        }
        this.currentPage += 1
        this.haveMore = true
        this.fetchUnSearchGoods()
        return
      }
      this.haveMore = true
      if (this.loginState) {
        this.fetchLoginData(true)
      } else {
        this.fetchNoLoginData(true)
      }
    },
    entoSearch () {
      this.searchPageShow = true
      this.$nextTick(() => {
        this.$refs.searchPageRef.$refs.searchInputTmpl.$refs.searchInput.focus()
      })
    },
    goSearchResult (searchText) {
      this.sortType = 0
      this.priceOrder = 1
      this.currentFilterItem = 'all'
      this.priceClickNum = 0
      this.searchPageShow = false
      this.currentPage = 1
      this.searchTig = searchText
      this.dataList = []
      this.unSearchIsNotData = true
      this.fetchDate()
      this.$router.replace({ name: this.$route.name, query: { search: searchText } })
    },
    searchResult (inputVal) {
      this.sortType = 0
      this.priceOrder = 1
      this.currentFilterItem = 'all'
      this.priceClickNum = 0
      this.searchPageShow = false
      this.currentPage = 1
      this.searchTig = inputVal
      this.dataList = []
      this.unSearchIsNotData = true
      this.fetchDate()
      this.$router.replace({ name: this.$route.name, query: { search: inputVal } })
    },
    hideInput () {
      this.searchPageShow = false
      this.$router.replace({ name: 'souhuo' })
    },
    // 进入详情页
    entoDetailPage (productID, isFreeCard) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: isFreeCard
        }
      })
    },
    // 进入免搜详情页
    entoUnSearchDetailPage (index) {
      this.writeInDbFromUnSearch(index)
    },
    // 前往商品搜索反馈
    goFeedback () {
      if (this.loginState) {
        this.$router.push({
          name: 'searchFeedback',
          query: {
            keyword: this.searchTig
          }
        })
      } else {
        this.unLoginModal()
      }
    },
    unLoginModal () {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 滚动监听
    handleScroll (e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop
      this.pageScrollTop = scrollTop
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.reFetchPage(from)
    })
  }
}
</script>
<style>
  .search_another {
    box-shadow: 0 4px 6px 3px rgba(0, 0, 0, 0.04);
  }
  .search_another .mint-search {
    height: auto;
  }
  .search_another .mint-search .mint-searchbar {
    background-color: #fff;
  }
  .search_another .mintui-search {
    font-size: 18px;
    margin: 0 6px;
  }
  .search_another .mint-searchbar-inner{
      border:none;
      border-radius: 5px;
      box-sizing: border-box;
  }
  .search_another .mint-searchbar-inner{
      background: #f0f0f0;
  }
  .search_another .mint-searchbar-core{
      background: #f0f0f0;
  }
</style>
<style scoped>
  .container{
    width:100%;
    height: 100%;
    background: #f5f5f5;
  }
  .souhuo_list{
    margin-top:88px;
  }
  .fixed_search{
    position: fixed;
    width:100%;
    top:0;
    left:0;
    z-index:100;
    background: #fff;
  }
  .t_999{
    color:#999;
  }
  .t_f23030{
    color:#f23030;
  }
  .s_result{
    display: flex;
    background: #fff;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    height:40px;
  }
  .r_tab{
    flex:1;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
    margin-top:3px;
    font-size: 14px;
  }
  .icon-div{ margin-left: 5px;}
  .sjx{
    width: 0;
    height: 0;
    border-left:4px solid transparent !important;
    border-right: 4px solid transparent !important;
  }
  .sjx-up{
    margin-bottom:2px;
    border-bottom:4px solid;
    border-bottom-color: #999;
  }
  .sanjiaoxing-up{
    margin-bottom:2px;
    border-bottom:4px solid;
    border-bottom-color: #f23030;
  }
  .sjx-down{
    border-top: 4px solid;
    border-top-color: #999;
  }
  .sanjiaoxing-down{
    border-top: 4px solid;
    border-top-color: red;
  }
  .icon-sanjiaoxing ,.icon-sanjiaoxing-copy{
    margin-left: 5px;
    margin-top:3px;
    font-size: 16px;
  }
  .sch-reult{
    position: relative;
    z-index:99;
    width: 100%;
  }
  .s_menban{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 98;
    background: #000;
    opacity: .3;
  }
  .r_tab_active{
    color: #f23030;
  }
  .s_key{
    background: #fff;
    position: absolute;
    top:41px;
    width: 100%;
    left:0;
  }
  .s_kword{
    display: flex;
    flex-wrap: wrap;
    padding-right: 15px;
  }
  .s_kword>div{
    width: calc( 33.33% - 17px);
    text-align: center;
    font-size: 13px;
    margin:15px 0px 0 15px;
    background: #f2f2f2;
    height:25px;
    line-height: 25px;
    border-radius:4px;
    border:1px solid #f2f2f2;
  }
  .boder_red{
    border:1px solid #f23030 !important;
    color: #f23030;
    background: #fff !important;
  }
  .s_button{
    display: flex;
    padding:30px 20% 0px 20%;
    justify-content: space-between;
  }
  .s_button>div{
    width:100%;
  }
  .s_title{
    padding:10px 0 0 15px;
    font-weight: bold;
    color: #999;
  }
  .btn_2c2c2c,.btn_f23030{
    width: 50%;
    height:35px;
    line-height:35px;
    text-align: center;
    position: relative;
    border-radius:40px;
    color: #fff;
    margin: 0 5px 15px 5px;
  }
  .s_button button{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
  .s_kword{
    max-height:200px;
    overflow-y: auto;
  }
  .btn_2c2c2c{
    background: #2c2c2c;
  }
  .btn_f23030{
    background: #f23030;
  }
  .hide{
    display: none;
  }
  .show{
    display: block;
  }
  .custom-bg{
    background-color: #fff;
    border-bottom-color: transparent;
    z-index:100;
  }
  .custom-input{
    background: #f5f5f5;
    border-color: transparent;
  }
  .brands{
    background: #fff;
    padding:0 10px 15px 10px;
    display: flex;
    flex-wrap: wrap;
    margin:6px 0 6px 0;
  }
  .b_flex{
    width: 20%;
    margin-top: 15px;
  }
  .b_img{
    width:40px;
    background: #f2f2f2;
    border-radius: 100%;
    height: 40px;
    margin: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .b_img image{
    width: 35px;
    height:35px;
  }
  .b_name{
    text-align: center;
    margin-top:5px;
    color: #666;
  }
  .img_active{
    opacity: 0.5;
  }
  .weui-search-bar{
    border-top: 1px solid #f2f2f2;
    border-bottom: none;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.04);
  }
  .brand_f23030{
    color:#f23030!important;
  }
  .feedback_btn{
    display: block;
    position: fixed;
    font-size: 14px;
    bottom: 30px;
    width: 70%;
    left: 50%;
    text-align: center;
    color: #20a0ff;
    transform: translateX(-50%);
    border:none;
    background: #fff;
    border-radius: 25px;
    padding: 8px 10px;
    box-shadow: 2px 4px 4px #ddd;
  }
  /** search */
  .souhuo_search_bar{
    border-top:1px solid #f2f2f2;
    box-shadow: 0 4px 6px 0px rgba(0,0,0,0.04);
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    overflow: hidden;
    background: #fff;
    z-index:100;
    position: relative;
  }
  .souhuo_search_label{
    border-top:1px solid #f2f2f2;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.04);
    width:100%;
    background: #eee;
    height: 28px;
    line-height: 28px;
    border-radius: 4px;
    color:#999;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
  }
  .souhuo_search_label>i{
    margin-right: 4px;
    position: absolute;
  }
  .souhuo_search_label .search_txt{
    display: inline-block;
    width: 100%;
    padding-left: 20px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
